/**
 * Definitionen für die motorbezogene Versicherungssteuer (MVS)
 */

// Fahrzeugklassen gemäß KFG
export enum FahrzeugKlasse {
  L1E_BIS_L5E = 'L1E_BIS_L5E',       // Motorräder und ähnliche Fahrzeuge
  M1_BIS_35T = 'M1_BIS_35T',         // PKW bis 3,5 Tonnen
  WOHNMOBIL_M1_SA = 'WOHNMOBIL_M1_SA', // Wohnmobile der Klasse M1 und Aufbauart "SA"
  ANDERE_BIS_35T = 'ANDERE_BIS_35T',  // Andere Fahrzeuge bis 3,5 Tonnen
  LKW_N1_BIS_35T = 'LKW_N1_BIS_35T'  // LKW bis 3,5 Tonnen (N1)
}

// Antriebsarten für Fahrzeuge
export enum Antriebsart {
  ELEKTRISCH = 'ELEKTRISCH',
  VERBRENNUNG = 'VERBRENNUNG',
  HYBRID_EXTERN_AUFLADBAR = 'HYBRID_EXTERN_AUFLADBAR',
  HYBRID_NICHT_EXTERN_AUFLADBAR = 'HYBRID_NICHT_EXTERN_AUFLADBAR'
}

// Zahlungsintervall-Optionen
export enum Zahlungsintervall {
  JAEHRLICH = 'JAEHRLICH',
  HALBJAEHRLICH = 'HALBJAEHRLICH',
  VIERTELJAEHRLICH = 'VIERTELJAEHRLICH',
  MONATLICH = 'MONATLICH'
}

// Eingabeparameter für die MVS-Berechnung
export interface MVSParams {
  fahrzeugKlasse: FahrzeugKlasse
  antriebsart: Antriebsart
  erstzulassungsDatum: Date
  motorLeistungKW: number
  hubraumCCM?: number
  co2EmissionGKM?: number
  eigengewichtKG?: number
  zahlungsintervall: Zahlungsintervall
  istFremdzuendungsMotorVor1987: boolean
  haeltSchadstoffgrenzwerteEin: boolean
}

// Ergebnis der MVS-Berechnung
export interface MVSErgebnis {
  monatlicheSteuer: number
  steuerProIntervall: number
  steuerJaehrlich: number
}

// Interface für die UI-Komponenten der Auswahl
export interface AuswahlOption<T> {
  wert: T
  label: string
} 